import type { LocationQueryValue } from '#vue-router'
export const queryValueToString = (
  queryValue: string | string[] | LocationQueryValue | LocationQueryValue[],
) => {
  if (queryValue === undefined) {
    return undefined
  } else if (typeof queryValue === 'string') {
    return queryValue
  } else {
    return queryValue?.[0] || undefined
  }
}

export const removeExceptNumbers = (v: string) => {
  return v.replace(/[^0-9]+/gi, '')
}

export const convertToNumber = (input: string | undefined): number => {
  if (!input) {
    return 0
  }
  const t = input
    // 全角数字を半角数字に変換
    .replace(/[０-９]/g, (match) =>
      String.fromCharCode(match.charCodeAt(0) - 0xfee0),
    )
    // 数字以外を削除
    .replace(/[^0-9]+/g, '')
  return Number(t)
}
